import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWindowWidth } from '@shared/hooks';
import { useProduct } from '@src/library/hooks/shop';
import Description from '../product/frames/Description';

export const DescriptionPage: FC = () => {
  const product = useProduct();

  const navigate = useNavigate();

  const windowWidth = useWindowWidth();

  return (
    <>
      {windowWidth <= 768 ? (
        <Description text={product.info.description} />
      ) : (
        navigate(`/shop/store/products/product/${product.productId}`)
      )}
    </>
  );
};
